var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app","dark":""}},[_c('Alerts',{attrs:{"alerts":_vm.alerts},on:{"dismissAlert":_vm.dismissAlert}}),_vm._v(" "),_c('AppBar'),_vm._v(" "),_c('v-main',{staticClass:"main-container",attrs:{"id":"main-container"}},[_c('nuxt'),_vm._v(" "),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }